import { render, staticRenderFns } from "./equiposEstadistica1.vue?vue&type=template&id=128f6ed5&"
import script from "./equiposEstadistica1.vue?vue&type=script&lang=js&"
export * from "./equiposEstadistica1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports